<!--
 * @Description: KaDa有声阅读馆-听书
 * @Author: xiehuaqiang
 * @FilePath: /kada-official-web/public/pc/src/views/introduction/StoryDesc.vue
 * @Date: 2020-12-17 10:47:50
-->
<template>
    <div class='module-cont module-story'>
        <div class="text-cont">
            <div class="title-style"><span class="fzlty-zc">KaDa</span>有声阅读馆-听书</div>
            <div class="desc-style">20000+趣味故事，让孩子从耳朵开始阅读</div>
        </div>
        <div class="icon-list-cont">
            <div class="icon-item" v-for="(item, index) in iconList" :key="index">
                <img class="left-cont" :src="item.imgUrl" alt="">
                <div class="right-cont">
                    <div class="first-line">{{item.firstLine}}</div>
                    <div class="second-line">{{item.secondLine}}</div>
                </div>
            </div>
        </div>
        <img class="mobile-icon" :src="mobileImg" alt="">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mobileImg: '//cdn.hhdd.com/frontend/as/i/c557faab-4cb0-52dd-8b5a-946cdd23febf.png',
                iconList: [
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/ea2874e2-2ff0-5bcd-8501-977fb4cb6330.png',
                        firstLine: '从听到读',
                        secondLine: '培养孩子阅读兴趣',
                    },
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/65bb9198-c58c-50cd-b9c6-362f997e42f5.png',
                        firstLine: '品质精选',
                        secondLine: '专业评选经典听书',
                    },
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/042807a7-fdc4-5bc8-b4eb-a0916c8fa349.png',
                        firstLine: '各类听书',
                        secondLine: '为儿童打造耳朵书房',
                    },
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/9406aaab-17c4-59ef-8e4c-6919c6216f3a.png',
                        firstLine: '专业演绎',
                        secondLine: '轻松让孩子走进故事',
                    }
                ]
            }
        },
    }
</script>

<style lang='stylus' scoped>
@import "../../style/vui/mixins"
.module-story
    background #F6F8FB
    position relative
    // margin-top px2rem2(44)
    padding px2rem2(44) px2rem2(16)
    
    .title-style
        text-align center
        color #3F3F3F
        font-size px2rem2(18)
        font-weight 600
    .desc-style
        text-align center
        margin-top px2rem2(6)
        color #3F3F3F
        font-size px2rem2(12)
    .icon-list-cont
        margin-top px2rem2(20)
        display flex
        flex-wrap wrap
        justify-content space-around
        .icon-item
            width 48%
            border-radius px2rem2(20)
            background #fff
            display flex
            align-items center
            color #666666
            font-size px2rem2(11)
            margin-bottom px2rem2(13)
            padding px2rem2(11) 0

            .left-cont
                width px2rem2(52)
                height px2rem2(52)
        
            .right-cont
                text-algin left

</style>



// WEBPACK FOOTER //
// src/views/home/StoryDesc.vue